import { Produktlinie } from './produktlinie.model';

export class KreditlinieRuled {

    produktlinien: Produktlinie[];

    entries: any[];

    public doDeserialize(input: any): KreditlinieRuled {
        this.produktlinien = [];

        for (const entry of input['produktlinien']) {
            const p: Produktlinie = new Produktlinie();
            p.produktlinie = entry['produktlinieName'];
            p.percent = entry['percent'];
            p.start = entry['start'];
            p.next = entry['next'];
            p.step = entry['step'];
            p.maximalHoehe = entry['maximalHoehe'];

            //nextProduktlinien immer leer initialisieren, auch wenn keine vorhanden sind
            p.nextProduktlinien = [];

            if (entry['nextProduktlinien']) {
                for (const nextProduktlinie of entry['nextProduktlinien']) {
                    p.nextProduktlinien.push(nextProduktlinie.produktlinie);
                }
            }

            this.produktlinien.push(p);
        }

        return this;
    }

    public getBeitrag(produktlinie: string, kreditlinie: number): number {
        const p: Produktlinie = this.getCurrentProduktlinie(produktlinie);

        return p.percent * kreditlinie / 100;
    }

    public getProduktlinienAuswahl(produktlinieAktuell: string): Produktlinie[] {
        const result: Produktlinie[] = [];
        const p: Produktlinie = this.getCurrentProduktlinie(produktlinieAktuell);
        result.push(p);

        for (const entry of p.nextProduktlinien) {
            for (const produktlinie of this.produktlinien) {
                if (entry === produktlinie.produktlinie) {
                    result.push(produktlinie);
                }
            }
        }

        return result;
    }

    public getCurrentProduktlinie(produktlinie: string): Produktlinie {
        for (const entry of this.produktlinien) {
            if (entry.produktlinie === produktlinie) {
                return entry;
            }
        }

        return null;
    }

    public max(produktlinie: string): number {
        const p: Produktlinie = this.getCurrentProduktlinie(produktlinie);

        return p.maximalHoehe;
    }

    public next(produktlinie: string, current: number): number {
        const p: Produktlinie = this.getCurrentProduktlinie(produktlinie);

        // Kein naechster Wert vorhanden, z.B. in Start, dann maximalWert
        if (p.next === 0) {
            return p.maximalHoehe;
        }

        // next ist der naechste gueltige Wert
        if (current < p.next) {
            return p.next;
        }

        // Nächsten Step zurueckgeben
        if (current > p.next) {
            // naechste 10000er zurueckgeben
            const value: number = current - (current % p.step) + p.step;
            if (value > p.maximalHoehe) {
                return p.maximalHoehe;
            }

            return value;
        }

        return p.next + p.step;
    }

    public previous(produktlinie: string, current: number): number {
        const p: Produktlinie = this.getCurrentProduktlinie(produktlinie);

        // Kein naechster Wert vorhanden, z.B. in Start, somit vorheriger ist Start-Wert
        if (p.next === 0) {
            return p.start;
        }

        let newCurrent: number = current - (current % p.step);

        // Glatter step war eingegeben
        if (current === newCurrent) {
            newCurrent -= p.step;
        }

        // Start ist der naechste kleinere Wert
        if (newCurrent < p.start) {
            return p.start;
        }

        return newCurrent;
    }

}
